module.exports = __webpack_public_path__ + "static/media/14.7608b157.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/14.png
// module id = 725
// module chunks = 0